import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { createInlineMarkupRegistry, EditableText } from '@/components/block-primitives';
import ConditionEditor from './condition-editor';
import type { ConditionOption } from './condition-options';
import type { ReportCondition } from './report-outline';
type SectionFooterProps = {
  when: ReportCondition | null;
  fallback: string;
  title: string;
  conditions: ConditionOption[];
  editable: boolean;
  onConditionChange: (when: ReportCondition | null) => void;
  onFallbackChange: (fallback: string) => void;
};
const markup = createInlineMarkupRegistry([]);

// The builder offers no new conditions. A section that already has one still shows it, since the
// agent is still handed it, and the author can remove it here.
const SectionFooter = t0 => {
  const $ = _c(23);
  const {
    when,
    fallback,
    title,
    conditions,
    editable,
    onConditionChange,
    onFallbackChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (!when) {
    return null;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-t border-tertiary" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== conditions || $[3] !== editable || $[4] !== onConditionChange || $[5] !== when) {
    t3 = <ConditionEditor editable={editable} onChange={onConditionChange} options={conditions} when={when} />;
    $[2] = conditions;
    $[3] = editable;
    $[4] = onConditionChange;
    $[5] = when;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-caption-2 text-tertiary">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== editable || $[12] !== fallback || $[13] !== onFallbackChange || $[14] !== t || $[15] !== title) {
    t6 = editable || fallback.trim() ? <EditableText as="div" block={true} className="-ml-1 rounded-sm px-1 py-0.5 text-body-2 text-primary opacity-100!" editable={editable} label={t(_temp2, {
      title
    })} multiline={true} onSubmit={onFallbackChange} optional={true} placeholder={t(_temp3)} registry={markup} value={fallback} /> : <p className="text-body-2 text-secondary">{t(_temp4)}</p>;
    $[11] = editable;
    $[12] = fallback;
    $[13] = onFallbackChange;
    $[14] = t;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t7) {
    t8 = <div className="mt-6 flex flex-col gap-6">{t2}<div className="flex flex-col gap-4">{t3}{t7}</div></div>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default SectionFooter;
function _temp($) {
  return $.fallbackLabel;
}
function _temp2($_0) {
  return $_0.fallbackAria;
}
function _temp3($_1) {
  return $_1.fallbackPlaceholder;
}
function _temp4($_2) {
  return $_2.fallbackEmpty;
}